import theme from '@efexteam/mui-theme';
import { css } from '@emotion/css';

const textContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  textAlign: 'center',
  marginBottom: theme.spacing(2),
});

const title = css({
  textAlign: 'right',
});

const linkContainer = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  justifyContent: 'center',
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(2),
  color: theme.palette.primary.light,
  marginBottom: theme.spacing(4),
  cursor: 'pointer',
});

const ObtainLinkStyles = {
  textContainer,
  title,
  linkContainer,
};

export default ObtainLinkStyles;
